import React, { useState } from 'react';
import axios from 'axios';
import '../Pincodefinder/Style.css';
import '../Steelcity/css/style.css';
import Logo from '../Logo/bdexpress.jpg';
import Swal from 'sweetalert2';

const BdexpressTracking = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<any[]>([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const statusToStep: { [key: string]: number } = {
    Booked: 1,
    InTransit: 2,
    DELIVERED: 3,
    Delivered: 4,
  };

  const handleButtonClick = () => {
    setShowImage(!showImage);
  };

  const fetchData = async () => {
    try {
      if (!searchValue.trim()) {
        setError('Please enter a tracking number.');
        return;
      }

      const docket = searchValue.trim();

      const res = await axios.get(
        'https://trackerex.com/BdexpressTrackingApi/TrackingData',
        {
          params: {
            awbNo: docket,
            refNo: docket,
          },
        }
      );

      const data = res.data;
      console.log(data, 'API response ====================');

      if (data?.status === 1 && Array.isArray(data.data)) {
        const tryImageExtensions = async (
          awbNo: string
        ): Promise<string | null> => {
          const extensions = ['jpg', 'jpeg', 'png'];
          for (const ext of extensions) {
            const url = `https://trackerex.com/DabhlogisticsPodimages/${awbNo}.${ext}`;
            const exists = await checkImageExists(url);
            if (exists) return url;
          }
          return null;
        };

        const checkImageExists = (url: string): Promise<boolean> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
          });
        };

        const updatedData = await Promise.all(
          data.data.map(async (item: any) => {
            const imageUrl = await tryImageExtensions(item.awbNo);
            return {
              ...item,
              ImageLink: imageUrl,
              podHistory: item.podHistory || [], // ✅ keep API podHistory
            };
          })
        );

        setTrackingData(updatedData);
        setError('');
        setSearchValue('');

        if (updatedData.length > 0) {
          const status = updatedData[0].Status;
          setCurrentStep(statusToStep[status] || 1);
        }
      } else {
        setTrackingData([]);
        Swal.fire({
          icon: 'warning',
          title: 'Docket Not Found',
          text: 'The entered docket number was not found.',
        });
      }
    } catch (error: any) {
      console.error('Error:', error);
      setTrackingData([]);
      setError(
        error.response?.data?.message ||
          'Failed to fetch data. Please check your internet connection.'
      );
    }
  };

  return (
    <>
      <div
        className="container-fluid py-3"
        style={{ marginBottom: '20px' }}
      >
        <div className="text-center text-lg-end mt-2 fw-semibold text-dark">
          📞 91 9870052525
        </div>
        <div className="row align-items-center">
          {/* Logo Section */}
          <div
            className="col-12 col-lg-3 text-center text-lg-start mb-3 mb-lg-0"
            style={{ marginTop: '20px' }}
          >
            <img
              src={Logo}
              alt="Company Logo"
              className="img-fluid"
              style={{ height: '100px', width: 'auto', marginTop: '-40px' }}
            />
          </div>

          {/* Navbar + Contact Info */}
          <div className="col-12 col-lg-9">
            <div className="d-flex flex-column">
              <nav className="navbar navbar-expand-lg navbar-dark bg-danger">
                <div className="container-fluid p-0">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div
                    className="collapse navbar-collapse"
                    id="navbarNavDropdown"
                  >
                    <ul className="navbar-nav ms-auto">
                      <li className="nav-item">
                        <a
                          className="nav-link text-white"
                          href="https://www.bdexpress.in/index.html"
                        >
                          Home
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link text-white"
                          href="https://www.bdexpress.in/about.html"
                        >
                          About
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link text-white"
                          href="https://www.bdexpress.in/service.html"
                        >
                          Services
                        </a>
                      </li>

                      <li className="nav-item">
                        <a
                          className="nav-link text-white"
                          href="https://www.bdexpress.in/Documents.html"
                        >
                          Document
                        </a>
                      </li>

                      <li className="nav-item">
                        <a
                          className="nav-link text-white"
                          href="https://www.bdexpress.in/contact.html"
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Search Box */}
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="shadow p-4">
              <input
                type="text"
                placeholder="Tracking Number(s)"
                className="form-control mb-2 text-center border border-info"
                value={searchValue}
                onChange={handleInputChange}
              />
              <button
                onClick={fetchData}
                className="Track1 w-100"
                style={{ backgroundColor: 'black' }}
              >
                TRACK HERE
              </button>
              {error && <div className="text-danger mt-2">{error}</div>}
              <p className="mt-2">To track multiple AwbNo</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tracking Data */}
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center">Tracking Details</h5>
                <table className="table table-bordered table-sm mb-4">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Ref_No</th>
                      <th>BookDate</th>
                      <th>Consignee_Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.awbNo}</td>
                      <td>{record.refNo || '-'}</td>
                      <td>{record.bookDate}</td>
                      <td>{record.consigneeName}</td>
                      <td>{record.Status}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Qty</th>
                      <th>Destination</th>
                      <th>Receiver Name</th>
                      <th>Delivery Date</th>
                      <th>Delivery Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.Qty}</td>
                      <td>{record.destinationName}</td>
                      <td>{record.recvName}</td>
                      <td>{record.DelvDT}</td>
                      <td>{record.DelvTime}</td>
                    </tr>

                    <tr>
                      <th>Mobile_No</th>
                      <td>{record.Destination_PIN}</td>
                      <td colSpan={5}>
                        <button
                          className="btn btn-success"
                          onClick={handleButtonClick}
                        >
                          {showImage ? 'Hide Image' : 'Pod Image'}
                        </button>
                        {showImage && (
                          <div className="image-container mt-2 text-center">
                            <img
                              src={record.ImageLink}
                              alt="Podimages"
                              className="img-fluid"
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Progress Steps */}
                <div
                  className="w-100 position-relative"
                  style={{ paddingBottom: '30px' }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      left: 0,
                      right: 0,
                      height: '4px',
                      backgroundColor: '#ccc',
                      zIndex: 0,
                    }}
                  >
                    <div
                      style={{
                        width: `${((currentStep - 1) / 2) * 100}%`,
                        height: '100%',
                        backgroundColor: '#007bff',
                        transition: 'width 0.3s ease',
                      }}
                    ></div>
                  </div>

                  <div
                    className="steps-container d-flex justify-content-between align-items-center my-3"
                    style={{ position: 'relative', zIndex: 1 }}
                  >
                    {['Booked', 'InTransit', 'DELIVERED'].map(
                      (stepLabel, idx) => {
                        const normalizedLabel = stepLabel.toLowerCase();
                        const stepNum = idx + 1;
                        const isActive = stepNum <= currentStep;

                        return (
                          <div
                            key={normalizedLabel}
                            className="text-center"
                            style={{ flex: 1 }}
                          >
                            <div
                              className={`step-circle ${
                                isActive ? 'active' : ''
                              }`}
                              style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                backgroundColor: isActive
                                  ? '#007bff'
                                  : '#ccc',
                                color: 'white',
                                lineHeight: '30px',
                                margin: '0 auto',
                                fontWeight: 'bold',
                              }}
                            >
                              {stepNum}
                            </div>
                            <div className="step-label mt-2">
                              {normalizedLabel.charAt(0).toUpperCase() +
                                normalizedLabel.slice(1)}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* POD History */}
            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center">Status Tracking</h5>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Status_Date</th>
                      <th>Status_Time</th>
                      <th>Location_Update</th>
                      <th>Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.podHistory?.map((history: any, idx: number) => (
                      <tr key={idx}>
                        <td>{history.Awbno}</td>
                        <td>{history.DelvDt}</td>
                        <td>{history.DelvTime}</td>
                        <td>{history.Destination_Name}</td>
                        <td>{history.Remark || history.Status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BdexpressTracking;
